import { AskDto } from '../../../services/dtos/ask.dto';
import { Button, Card, CardContent, CardHeader, Container, Grid, Paper, Typography } from '@mui/material';
import imgMeterReading from '../../../assets/images/releveCompteur.png';
import { date, number, object } from 'yup';
import React from 'react';
import { Form, Formik } from 'formik';
import './meter-reading.form.scss';
import { Link } from 'react-router-dom';
import moment from 'moment';
import MeterReading from '../../commun/meter-reading';
import InputForm from '../../commun/input-form';

/**
 * Composant la page relevè de compteur
 * @constructor
 */
export default function MeterReadingForm(props: {
    lastAsk: AskDto | undefined;
    address: string | undefined;
    handleSumbitForm: (values: any) => void;
    validForm: boolean;
    id: string | undefined;
}) {
    // Message affiché dès que l'utilisateur oublira un champ du formulaire
    const message = 'Champ obligatoire';
    // Message affiché dès que l'utilisateur enverra une date future
    const messageFuturDate = 'La date de relevé ne peut pas être ultérieure à celle du jour';

    // Schéma de validation des données
    const validationSchema = object({
        numberOne: number().required(message),
        numberTwo: number().required(message),
        numberThree: number().required(message),
        numberFour: number().required(message),
        numberFive: number().required(message),
        date: date().required(message).max(new Date(), messageFuturDate),
    });

    // Valeurs par défaut
    const iniValues = {
        numberOne: '',
        numberTwo: '',
        numberThree: '',
        numberFour: '',
        numberFive: '',
        date: moment(new Date(), true).format('yyyy-MM-DD'),
    };

    // Création de la page
    return (
        // Mise en place d'une card
        <Card className="meter-reading-form">
            <CardHeader title={<Typography variant="h5">Je relève mon compteur</Typography>}></CardHeader>
            <CardContent>
                {/*Ajout d'une phrase explicative sur la dernière demande*/}
                {/*Si pas de dernière demande alors ne rien afficher*/}
                {props.lastAsk ? (
                    <>
                        <Typography variant="body1" sx={{ marginBottom: '15px' }}>
                            <Typography component="span" sx={{ fontWeight: 'bold' }}>
                                Avertissement :{' '}
                            </Typography>{' '}
                            Une déclaration d'index a déjà été effectuée le{' '}
                            {moment(props.lastAsk?.dateCreation, true).format('DD/MM/yyyy')}. Vous pouvez la retrouver
                            dans "Mes demandes"
                        </Typography>
                    </>
                ) : (
                    ''
                )}
                {/*Phrase explicative pour les abonnés*/}
                <Container sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Paper elevation={2} className="imgText">
                        {/*image + texte explicatif*/}
                        <img src={imgMeterReading} alt="Relevè de compteur" />
                        <Typography variant="body1">
                            Pour transmettre votre relevé de compteur, veuillez communiquer uniquement le nombre blanc
                            sur fond noir présent sur votre compteur
                        </Typography>
                    </Paper>
                </Container>
                <Typography variant="h5">Renseignez ci-dessous le nouvel index</Typography>
                <Typography variant="body1">{props.address}</Typography>
                <Typography variant="body1">Relevé du compteur : (*)</Typography>
                {/*Formulaire avec tableau pour afficher correctement les champs*/}
                <Formik initialValues={iniValues} onSubmit={props.handleSumbitForm} validationSchema={validationSchema}>
                    <Form>
                        {/*Début grid*/}
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <MeterReading columNumber={12} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputForm
                                    id="date"
                                    name="date"
                                    type={'date'}
                                    required
                                    label={'Date du relevé'}
                                ></InputForm>
                            </Grid>
                            {/*Actions du formulaire*/}
                            <Grid item xs={0} sm={9}></Grid>
                            <Grid item xs={12} sm={3}>
                                <Typography variant={'button'} className={'buttons-form'}>
                                    {/*bouton annulé*/}
                                    <Button
                                        variant="neutral"
                                        component={Link}
                                        to={props.id === undefined ? '/releve-compteur' : '/contrat/' + props.id}
                                    >
                                        Retour
                                    </Button>
                                    {/*bouton valider*/}
                                    <Button type="submit" variant="contained" disabled={!props.validForm}>
                                        Valider
                                    </Button>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </CardContent>
        </Card>
    );
}
